<template>
  <div class="phone-interface-data">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" size="mini">
            <el-form-item label="客户姓名" prop="customerName">
              <el-input class="form-input" v-model="searchForm.customerName" clearable></el-input>
            </el-form-item>
            <el-form-item label="客户手机号" prop="customerPhone">
              <el-input class="form-input" v-model="searchForm.customerPhone" clearable></el-input>
            </el-form-item>
            <el-form-item label="授权时间">
              <form-date-range
                :form="searchForm"
                startKey="authDateStart"
                :usingTime="false"
                endKey="authDateEnd"
                valueFormat="yyyyMMdd"
              />
            </el-form-item>
            <!-- <el-form-item label="授权时间">
              <q-date-picker
                v-model="searchForm"
                startFiled="authDateStart"
                endFiled="authDateEnd"
                :isDefault="false"
                ref="dateRef"
              />
            </el-form-item> -->
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="customerName" label="客户姓名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerPhone" label="客户手机号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="authDate" label="授权时间" align="center" show-overflow-tooltip min-width="160"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin'

export default {
  name: 'phoneInterfaceData',
  mixins: [tableMixin],
  data () {
    return {
      searchForm: {
        customerName: '',
        customerPhone: '',
        authDateStart: '',
        authDateEnd: ''
      },
      tableData: [],
      pageSize: 50,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70
    }
  },
  methods: {
    init () {
      this.onSearch()
    },
    getList () {
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.dataReport
        .queryCustomerPhoneAuthList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || []
          this.total = total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.getList()
    },
    onNumChange (pageNum) {
      this.pageNum = pageNum
      this.getList()
    },
    resetSearchForm () {
      this.$refs.searchForm.resetFields()
      this.filterParam = {}
      this.onSearch()
    },
    onSearch () {
      this.filterParam = {}
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val
        }
      }
      this.pageNum = 1
      this.getList()
    },
    exportList () {
      const params = {
        ...this.filterParam
      }
      this.$api.common.doExport('queryCustomerPhoneAuthList', params).then(() => {
        this.$message.success('导出操作成功，请前往导出记录查看详情')
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
